export default "__VITE_ASSET__C8b49Kdy__"